import React, {Component} from 'react';
import styles from '../css/AddHCP_P3.module.css';

class AddHCP_P3 extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        return (
            <div className={styles.editScreen}>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        <div></div>
                        <div className={styles.TitleText}>Add Professional</div>
                        <div className={styles.close} onClick={() => {
                            this.props.close()
                        }}><i className="fas fa-times"></i></div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.toprow}>
                            <div className={[styles.set, styles.mainTitle].join(' ')}>
                                <div className={styles.titleText}>Please confirm the details:</div>
                            </div>
                        </div>

                        <div className={styles.middlerow}>
                            <div className={[styles.set, styles.odd].join(' ')}>
                                <div className={styles.contentTitle}>NAME</div>
                                <div className={styles.content}>{this.props.info.FIRST_NAME}{this.props.info.MIDDLE_NAME !== -1 ? ` ${this.props.info.MIDDLE_NAME} ` : " "}{this.props.info.LAST_NAME}</div>
                            </div>
                            <div className={styles.set}>
                                <div className={styles.contentTitle}>SPECIALTY</div>
                                <div className={styles.content}>{this.props.info.SPECIALTY}</div>
                            </div>
                            <div className={[styles.set, styles.odd].join(' ')}>
                                <div className={styles.contentTitle}>DEGREE</div>
                                <div className={styles.content}>{this.props.info.DEGREE}</div>
                            </div>
                            <div className={styles.set}>
                                <div className={styles.contentTitle}>PRIMARY ADDRESS</div>
                                <div className={styles.content}>{this.props.info.ADDRESS1} {this.props.info.ADDRESS2 !== null ?  this.props.info.ADDRESS2 : ''} {this.props.info.CITY}, {this.props.info.STATE}, {this.props.info.ZIPCODE}</div>
                            </div>
                            <div className={[styles.set, styles.odd].join(' ')}>
                                <div className={styles.contentTitle}>ADD REASON</div>
                                <div className={styles.content}>{this.props.info.REQUEST_TYPE}</div>
                            </div>
                            <div className={styles.set}>
                                <div className={styles.contentTitle}>COMMENTS</div>
                                <div className={styles.content}>{this.props.info.REQUEST_NOTE === -1 ? "" : this.props.info.REQUEST_NOTE}</div>
                            </div>
                        </div>

                        <div className={styles.buttonRow}>
                            <div id={styles.cancel} onClick={() => {
                                this.props.nextPage(1);
                            }}>BACK</div>
                            <div id={styles.submit} onClick={() => {
                                this.props.submit(this.props.info);
                                this.props.nextPage(3);
                            }}>SUBMIT</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default AddHCP_P3;
